import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  // requestSingle,
  requestAdd,
  requestGetStatuses,
} from "./requests";

import {
  PROMO_CODES_LOADING,
  PROMO_CODES_ERROR,
  // PROMO_CODES_LIST,
  PROMO_CODES_FILTERS,
  PROMO_CODES_CREATE,
  PROMO_CODES_STATUSES,
  PROMO_CODES_SEARCH,
  // PROMO_CODES_UPDATE,
  // PROMO_CODES_DELETE
} from "./constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: PROMO_CODES_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("promo-code")
    .then(response => {
      dispatch({
        type: PROMO_CODES_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, PROMO_CODES_ERROR));
    });
};

export const getSearch = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("promo-code", page, size, sort, filters)
    .then((response) => {
      dispatch({
        type: PROMO_CODES_SEARCH,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, PROMO_CODES_ERROR));
    });
};

export const create = (data, callback) => dispatch => {
  requestAdd(data)
    .then(response => {
      dispatch({
        type: PROMO_CODES_CREATE,
        payload: response.data
      });
      toast(`Tag ${data.id ? "updated" : "created"} successfully`, {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, PROMO_CODES_ERROR));
    });
};

export const getStatuses = () => dispatch => {
  requestGetStatuses()
    .then((response) => {
      dispatch({
        type: PROMO_CODES_STATUSES,
        payload: response.data.content,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, PROMO_CODES_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/promo-codes/actions.js